import { render, staticRenderFns } from "./AgentDomainHistory.vue?vue&type=template&id=501b868a&"
import script from "./AgentDomainHistory.vue?vue&type=script&lang=js&"
export * from "./AgentDomainHistory.vue?vue&type=script&lang=js&"
import style0 from "./AgentDomainHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports